module.exports = __webpack_public_path__ + "static/desktop/img/material-calendar.86eacf7b.png";